import { Link } from 'react-router-dom';
import Breadcrumb from '@/components/base/Breadcrumb';
import RelatedPages from '@/components/base/RelatedPages';

const services = [
  {
    icon: 'ri-scales-3-line',
    tag: '01',
    title: '法規風險管控',
    subtitle: '上市前合規，讓品牌走得更穩',
    desc: '協助釐清食品保健相關法規資訊，有效降低生產風險。康永具備豐富的食品法規實務經驗，在配方確定前即進行法規前置審查，確認原料合規性與宣稱文字符合台灣規範，讓您的產品從起點就站在合規的基礎上。',
    points: [
      '原料正面表列審查，確認成分合法可用',
      '相關劑型產品生產檢驗規範',
      '健康食品認證（小綠人標章）申請支援',
      '協助審核食品包裝標示、行銷文案用詞',
    ],
    img: 'https://readdy.ai/api/search-image?query=professional%20legal%20compliance%20document%20review%20health%20supplement%20regulatory%20affairs%20specialist%20checking%20ingredient%20list%20certification%20papers%20in%20clean%20office%2C%20minimal%20modern%20environment&width=640&height=420&seq=csvc-reg-01&orientation=landscape',
    cta: '了解法規風險',
    ctaLink: '/about/regulation',
  },
  {
    icon: 'ri-quill-pen-line',
    tag: '02',
    title: '行銷素材',
    subtitle: '熟悉 產品 ，幫您說對話、說好話',
    desc: '可協助 支援提供產品相關行銷素材 。 從產品介紹簡報、產品宣傳 DM 、網站相關產品介紹圖，讓客戶可以更了解產品，並精準且輕鬆的推廣好的營養給消費者。',
    points: [
      '提供產品相關之教育訓練簡報',
      '產品宣傳之 DM 、海報素材',
      '產品可於宣傳之用詞建議',
    ],
    img: 'https://readdy.ai/api/search-image?query=creative%20marketing%20team%20working%20on%20health%20supplement%20product%20packaging%20design%20copywriting%20brainstorming%20on%20whiteboard%2C%20professional%20agency%20environment%2C%20clean%20bright%20workspace&width=640&height=420&seq=csvc-copy-01&orientation=landscape',
    cta: '諮詢文案服務',
    ctaLink: '/cooperation/inquiry',
  },
  {
    icon: 'ri-ship-line',
    tag: '03',
    title: '進口原料代購',
    subtitle: '省去繁瑣流程，讓好原料直達您手中',
    desc: '協助代購進口原料，歡迎洽詢相關代購資訊。康永長期與國際原料供應商合作，熟悉進口流程、關稅申報與品質認證要求，可協助客戶以合理價格取得高品質的國際認證原料，省去自行開發供應商的時間與風險。',
    points: [
      '日本、美國、歐洲等地認證原料代購',
      '協助確認原料規格書與安全認證文件',
      '批量採購享優惠價格轉讓',
      '進口申報、檢驗相關文件協助',
    ],
    img: 'https://readdy.ai/api/search-image?query=international%20raw%20material%20import%20shipping%20containers%20herbs%20botanical%20extracts%20high%20quality%20natural%20ingredients%20sourcing%20global%20supply%20chain%2C%20professional%20logistics%20health%20supplement%20industry&width=640&height=420&seq=csvc-import-01&orientation=landscape',
    cta: '洽詢代購服務',
    ctaLink: '/cooperation/inquiry',
  },
  {
    icon: 'ri-rocket-line',
    tag: '04',
    title: '彈性客製方案',
    subtitle: '擁有成熟熱銷配方，快速拓展產品線',
    desc: '專業成熟半成品，可協助品牌快速拓展產品支線。對於想測試新市場或拓展品項的品牌，以小批量快速上市，驗證銷售反應後再決定是否放大量產規模，降低庫存積壓風險。',
    points: [
      '成熟配方縮短開發週期，快速上市',
      '可提供多款既有配方供選擇',
      '市場驗證後無縫銜接量產',
    ],
    img: 'https://readdy.ai/api/search-image?query=small%20batch%20supplement%20product%20launch%20health%20brand%20new%20product%20launch%20fast%20to%20market%20concept%20bottles%20capsules%20arranged%20neatly%2C%20clean%20minimal%20product%20photography%20startup%20brand&width=640&height=420&seq=csvc-launch-01&orientation=landscape',
    cta: '了解少量起訂',
    ctaLink: '/cooperation/inquiry',
  },
];

export default function CoopServicesContent() {
  return (
    <>
      {/* Hero Banner */}
      <section className="relative pt-20 min-h-[360px] md:min-h-[420px] flex items-end overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=diverse%20professional%20services%20health%20biotech%20company%20offering%20multiple%20solutions%20consultation%20meeting%20team%20of%20experts%20in%20modern%20bright%20office%2C%20collaborative%20atmosphere%20clean%20minimal%20interior&width=1920&height=420&seq=csvc-hero-bg-01&orientation=landscape"
            alt="其他服務背景"
            className="w-full h-full object-cover object-center"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-[#1a3a1a]/90 via-[#1a3a1a]/65 to-[#1a3a1a]/20" />
        </div>
        <div className="relative z-10 w-full max-w-screen-xl mx-auto px-6 lg:px-10 pb-14 pt-28">
          <div className="max-w-2xl">
            <div className="mb-5">
              <div className="inline-block bg-black/8 backdrop-blur-sm rounded-lg px-3 py-1.5" style={{ textShadow: '0 1px 4px rgba(0,0,0,0.5)' }}>
                <Breadcrumb
                  items={[
                    { label: '首頁', href: '/' },
                    { label: '合作相關', href: '/cooperation' },
                    { label: '其他服務' },
                  ]}
                  textClassName="text-white"
                />
              </div>
            </div>
            <span className="inline-block bg-[#4CAF50]/30 border border-[#4CAF50]/40 text-white text-[0.875rem] font-semibold px-4 py-1.5 rounded-full mb-5 shadow-[0_1px_3px_rgba(0,0,0,0.2)]">
              合作相關
            </span>
            <h1 className="text-white font-bold text-[2.25rem] md:text-[2.875rem] leading-tight mb-4">
              其他服務
            </h1>
            <p className="text-gray-200 text-[0.9375rem] md:text-[1.0625rem] leading-[1.75] max-w-3xl">
              除代工製造外，康永生技提供多項加值服務，協助品牌從法規、文案到上市全方位做好準備。
            </p>
          </div>
        </div>
      </section>

      {/* Services */}
      <section className="py-20 bg-white">
        <div className="max-w-screen-xl mx-auto px-6 lg:px-10 space-y-20">
          {services.map((svc, idx) => (
            <div
              key={svc.tag}
              className={`flex flex-col ${idx % 2 === 1 ? 'lg:flex-row-reverse' : 'lg:flex-row'} gap-12 lg:gap-16 items-center`}
            >
              {/* Text */}
              <div className="w-full lg:w-1/2">
                <div className="flex items-center gap-3 mb-4">
                  <span className="text-[#4CAF50] font-bold text-[1.75rem] leading-none opacity-20">{svc.tag}</span>
                  <div className="w-10 h-10 flex items-center justify-center bg-green-50 rounded-xl border border-green-200">
                    <i className={`${svc.icon} text-[#4CAF50] text-xl`} />
                  </div>
                </div>
                <h2 className="text-[#1a2e1a] font-bold text-[1.75rem] leading-tight mb-2">{svc.title}</h2>
                <p className="text-[#4CAF50] font-medium text-[1rem] mb-5">{svc.subtitle}</p>
                <p className="text-gray-600 text-[1.0625rem] leading-[1.75] mb-6">{svc.desc}</p>
                <ul className="space-y-3 mb-7">
                  {svc.points.map((pt) => (
                    <li key={pt} className="flex items-start gap-3">
                      <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                        <i className="ri-checkbox-circle-fill text-[#4CAF50] text-lg" />
                      </div>
                      <span className="text-gray-600 text-[0.9375rem] leading-[1.75]">{pt}</span>
                    </li>
                  ))}
                </ul>
                <Link
                  to={svc.ctaLink}
                  className="whitespace-nowrap inline-flex items-center gap-2 bg-[#4CAF50] hover:bg-[#43a047] text-white font-semibold text-[0.9375rem] px-7 py-3.5 rounded-full transition-all duration-300 cursor-pointer"
                >
                  {svc.cta}
                  <i className="ri-arrow-right-line" />
                </Link>
              </div>
              {/* Image */}
              <div className="w-full lg:w-1/2">
                <div className="rounded-2xl overflow-hidden">
                  <img
                    src={svc.img}
                    alt={svc.title}
                    className="w-full h-[300px] lg:h-[360px] object-cover object-top"
                  />
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Summary cards */}
      <section className="py-16 bg-[#f7faf7]">
        <div className="max-w-screen-xl mx-auto px-6 lg:px-10">
          <div className="text-center mb-10">
            <h2 className="text-[#1a2e1a] font-bold text-[1.75rem] md:text-[2rem] mb-3">
              不只是代工，更是全方位夥伴
            </h2>
            <p className="text-gray-500 text-[1.0625rem] leading-[1.75] max-w-2xl mx-auto">
              康永生技提供的服務，從法規到文案，從原料到上市，讓您每個環節都有專業支援
            </p>
          </div>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-10">
            {services.map((svc) => (
              <div key={svc.tag} className="bg-white rounded-xl p-5 border border-gray-100 text-center hover:border-green-200 transition-all duration-300">
                <div className="w-12 h-12 flex items-center justify-center bg-green-50 rounded-xl mx-auto mb-3 border border-green-100">
                  <i className={`${svc.icon} text-[#4CAF50] text-xl`} />
                </div>
                <h3 className="text-[#1a2e1a] font-bold text-[0.9375rem]">{svc.title}</h3>
              </div>
            ))}
          </div>
          <div className="text-center">
            <Link
              to="/contact/form"
              className="whitespace-nowrap inline-flex items-center gap-2 bg-[#4CAF50] hover:bg-[#43a047] text-white font-bold text-[1.0625rem] px-10 py-4 rounded-full transition-all duration-300 cursor-pointer"
            >
              洽詢其他服務
              <i className="ri-arrow-right-line" />
            </Link>
          </div>
        </div>
      </section>
      <RelatedPages items={[
        { title: '合作流程', desc: '從需求對焦到完成交貨，清楚掌握合作的每個步驟。', href: '/cooperation/process' },
        { title: '法規風險', desc: '了解保健食品法規要點，從源頭防範法規風險。', href: '/about/regulation' },
        { title: '包裝設計', desc: '包材選擇、視覺設計到法規標示，一站式包裝方案。', href: '/services/packaging' },
      ]} />
    </>
  );
}
